import { render, staticRenderFns } from "./CartItemCombo.vue?vue&type=template&id=b12c720a&scoped=true"
import script from "./CartItemCombo.vue?vue&type=script&lang=js"
export * from "./CartItemCombo.vue?vue&type=script&lang=js"
import style0 from "./CartItemCombo.vue?vue&type=style&index=0&id=b12c720a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c720a",
  null
  
)

export default component.exports